import { render, staticRenderFns } from "./block-documents-list-item-status-icon.vue?vue&type=template&id=d6f4852c&scoped=true&lang=pug"
import script from "./block-documents-list-item-status-icon.vue?vue&type=script&lang=js"
export * from "./block-documents-list-item-status-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f4852c",
  null
  
)

export default component.exports